import gql from 'graphql-tag';

export const GET_TOTAL_VENUE_INSIGHTS = gql`
  query getTotalVenueInsights($dataScope: DataScope!, $locationId: ID!, $startAt: ISO8601DateTime!, $endAt: ISO8601DateTime!) {
    totalVenueInsights(dataScope: $dataScope, locationId: $locationId, startAt: $startAt, endAt: $endAt) {
      total
    }
  }
`;
